<template>
    <div>
        <buttonlist @help="help" @add="add" @search="search" @reflash="reflash" @del="delall" @exps="exp" @imp="imp" @save="sava" ref="SetBtn"></buttonlist>
        <div style="display: flex">
            <div style="width:20%;">
                <el-card class="box-card" style="height:100%">
                    <div style="margin-top:5px;inbackground: white">
                        <el-scrollbar style="height:100%;width: 100%;">
                            <el-tree :data="dataTree" :props="defaultProps" default-expand-all="true" @node-click="handleNodeClick"></el-tree>
                        </el-scrollbar>
                    </div>
                </el-card>
            </div>
            <div style="width:80%">
                <el-card class="box-card" style="height:100%">
                    <el-table
                        id="xpane-0"
                        :data="dataSet"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight"
                        @cell-dblclick="editInfo"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                        :header-cell-style="$limits.headerClass"
                        ref="singleTable"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Exclusively_ID" label="ID"
                                     v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="GroupName" :label="$t('getapi[3215]')" width="200"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="RoleID" :label="$t('getapi[3216]')" width="200"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="RoleName" :label="$t('getapi[3217]')" width="200"></el-table-column>
                                        <el-table-column :label="$t('getapi[6048]')" width="60">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="editInfo(scope.row)" type="text" size="small">{{
                                $t('getapi[34]') }}
                            </el-button>
                            <el-popconfirm
                                    :confirmButtonText="$t('getapi[937]')"
                                    :cancelButtonText="$t('getapi[6]')"
                                    icon="el-icon-info"
                                    iconColor="red"
                                    :title="$t('getapi[637]')"
                                    @onConfirm="del(scope.row)"
                            >
                                <el-button slot="reference" type="text" size="small" :disabled="!authority_del">{{ $t('getapi[40]') }}</el-button>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>
                </el-card>
            </div>
        </div>
        <serce :isVisible="isVisible" queryData="FrmUserRoleShowViewInfo" ref="ser" @getser="serclick"></serce>

        <el-dialog v-dialogDrag :visible.sync="isShowDetail" width="50%" top="50px">
            <div style="display: flex;margin-bottom: 20px">
                <div style="width:30%">
                    <div>
                        <el-divider content-position="left">{{$t('getapi[3562]')}}</el-divider>
                        <table>
                            <tr>
                                <td>{{$t('getapi[3216]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.RoleID" type="text" size="mini" :disabled="true"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{$t('getapi[3217]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.RoleName" type="text" size="mini"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{$t('getapi[3215]')}}</td>
                                <td>
                                    <el-select filterable v-model="dataDetail.GroupName" size="mini">
                                        <el-option v-for="item in arrGroup" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                                    </el-select>
                                    <!--<el-input v-model="dataDetail.GroupName" type="text" size="mini"></el-input>-->
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div>
                        <el-divider content-position="left">{{$t('getapi[3563]')}}</el-divider>
                        <el-checkbox v-model="maxauthority"></el-checkbox>{{$t('getapi[6070]')}}
                    </div>
                </div>
                <div style="width:70%">
                    <div style="display: flex">
                        <div style="width:60%">
                            <el-divider content-position="left">{{$t('getapi[3547]')}}</el-divider>
                            <table>
                                <td>{{$t('getapi[3548]')}}</td>
                                <td>
                                    <el-input v-model="treeQueryKey" type="text" size="mini"></el-input>
                                </td>
                                <td><el-button size="mini" @click="searchTree">{{$t('getapi[1980]')}}</el-button></td>
                                <td><el-button size="mini" @click="back">{{$t('getapi[3549]')}}</el-button></td>
                                <td><el-button size="mini" @click="next">{{$t('getapi[3550]')}}</el-button></td>
                            </table>
                        </div>
                    </div>
                    <div style="height:600px">
                        <el-divider content-position="left">{{$t('getapi[6071]')}}</el-divider>
                        <div style="height:100%;width: 100%;overflow: scroll" id="searchtree-eletree">
                            <el-tree
                                    ref="tree"
                                    :data="detailDataTree"
                                    :props="detailDefaultProps"
                                    show-checkbox
                                    check-strictly
                                    node-key="PerID"
                                    highlight-current
                                    :default-checked-keys="defaultchecked"
                                    @check="handleCheck"
                                    :default-expanded-keys="defaultEexpandedkeys"
                                    :filter-node-method="filterNode"
                            ></el-tree>
                        </div>
                    </div>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowDetail = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="save" :disabled="!authority_edit">{{$t('getapi[937]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
		name:'roleauthorityset',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-180
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                isShowDetail: false, //
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataDetail:{},
                dataTree: [], // 角色分类树
                defaultProps: {
                    children: 'Children',
                    label: 'groupname',
                    id: 'groupid'
                },
                detailDataTree: [],
                detailDefaultProps: {
                    children: 'Children',
                    label: 'PerName',
                    PLevel:'PLevel',
                    ParentID:"ParentID",
                    PerID:"PerID",
                    PerType:'PerType',
                    PerMainPos:'PerMainPos',
                    PerSubPos:'PerSubPos',
                    MainPos:'MainPos',
                    IsCheck:'IsCheck',
                },
                defaultchecked: [],
                maxauthority: false, // 是否默认获取最大权限
                treeQueryKey: "",//查询树节点关键词
                searchIndex: null,
                searchData: [], //模糊匹配的树节点
                defaultEexpandedkeys:[],
                arrGroup: [],
                addoredit: 2, // 1:修改2：新增
                queryData: [], // 查询数组
                authority_edit: false,
                authority_del: false,
                scrollTop:0,
            };
        },
        created: function() {
            let that = this;
            that.arrGroup = Array.methods.getRoleGroup();
        },

        mounted: function () {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
            that.getView()
            that.authority();
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            filterNode(value,data){
                return data.Visiable == value
            },
            filterChange(){
                this.$nextTick(() => {
                    this.$refs.tree.filter(1)
                    // 当执行过滤后，会默认展开，这边遍历树，全部收缩
                    this.shrink().filter(this.detailDataTree);
                })
            },
            shrink: function(){
                let that = this
                let shrink_ = function(obj) {
                    if (undefined == obj || null == obj || obj.length == 0) {
                        return;
                    }
                    if (obj.PerID != '-') {
                        that.$refs.tree.store.nodesMap[obj.PerID].expanded = false
                    }
                    if (null != obj.Children && obj.Children.length != 0) {
                        for (let child of obj.Children) {
                            shrink_(child);
                        }
                    }
                };
                return {
                    filter: function(arr) {
                        if (arr.length == 0) {
                            return false;
                        }
                        for (let rootMenu of arr) {
                            shrink_(rootMenu);
                        }
                    }
                };
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1072]"),this.$t("getapi[12]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权
                if (that.$limits.authority('plv2', 501, 1) == 1) {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                }
                //操作权
                if (that.$limits.authority('plv2', 501, 1) == 2) {
                    //查询级
                    if (that.$limits.authority('plv3', 501, 1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        that.authority_edit = false;
                        that.authority_del = false;
                    }
                    if (that.$limits.authority('plv3', 501, 1) == 1) {
                        //编辑级
                        that.$refs.SetBtn.SetButtonEnable('create,search,refresh');
                        that.authority_edit = true;
                        that.authority_del = false;
                    }
                    if (that.$limits.authority('plv3', 501, 1) == 2) {
                        //删除级
                        that.$refs.SetBtn.SetButtonEnable('create,search,refresh');
                        that.authority_edit = true;
                        that.authority_del = true;
                    }
                }
                
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.getView();
                this.intidata();
            },
            getView(){
                let that = this
                that.loading = true;
                let parm = {}
                that.$http.urlpost('/Sys/Authority/GetRoleGroups', parm, function (res) {
                    if (res.Success == 1) {
                        let tree = res.DataContent;
                        that.dataTree = [{
                            GroupName: "",
                            GroupID: "",
                            Children: []
                        }]
                        that.dataTree[0].groupname = "角色分类"
                        that.dataTree[0].groupid = ""
                        that.dataTree[0].Children = tree
                        that.loading = false;
                    }
                });
            },
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'FrmUserRoleShowViewInfo');
            },
            reflash() {
                let that = this;
                that.getView();
                that.intidata()
            },
            handleNodeClick(data){
                let that = this
                let parm = {
                    Id: data.groupid
                }
                that.$http.urlpost('/Sys/Authority/GetRoleGroupList', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                    }
                });
            },
            intidata(){
                let that = this
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    Param: datac
                };
                that.$http.urlpost('/Sys/Authority/GetRoleGroupList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                    }
                });
            },
            add(){
                let that = this
                that.isShowDetail = true
                that.addoredit = 2
                that.treeQueryKey = ''
                that.defaultEexpandedkeys = []
                let parm = {
                    cfstate: 0,
                    keytype: "",
                    roleid: 0
                }
                that.$http.urlpost('/Sys/Authority/GetRoleAuthorityList', parm, function (res) {
                    if (res.Success == 1) {
                        that.detailDataTree = res.DataContent.RolePer
                        that.defaultEexpandedkeys.push('-')
                        that.filterChange()
                    }
                });
            },
            editInfo(data) {
                let that = this
                that.isShowDetail = true
                that.defaultEexpandedkeys = []
                that.treeQueryKey = ''
                that.dataDetail = data
                that.addoredit = 1
                let parm = {
                    cfstate: 2,
                    keytype: "",
                    roleid: data.RoleID
                }
                that.$http.urlpost('/Sys/Authority/GetRoleAuthorityList', parm, function (res) {
                    if (res.Success == 1) {
                        that.detailDataTree = res.DataContent.RolePer
                        that.tickMenuIdFilter().filter(that.detailDataTree);
                        that.defaultEexpandedkeys.push('-')
                        that.filterChange()
                    }
                });
            },
            tickMenuIdFilter: function() {
                let that = this
                that.defaultchecked = [];
                let parentPerIDArr = []
                let getTickMenuId = function(obj) {
                    if (undefined == obj || null == obj || obj.length == 0) {
                        return;
                    }
                    if (obj.IsCheck == true) {
                        that.defaultchecked.push(obj.PerID);
                    }
                    if (null != obj.Children && obj.Children.length != 0) {
                        for (let child of obj.Children) {
                            getTickMenuId(child);
                        }
                    }
                };
                return {
                    filter: function(arr) {
                        if (arr.length == 0) {
                            return false;
                        }
                        for (let rootMenu of arr) {
                            getTickMenuId(rootMenu);
                        }
                        that.$refs.tree.setCheckedKeys(that.defaultchecked)
                        return that.defaultchecked;
                    }
                };
            },
            save() {
                let that = this
                let parm = {
                    cfstate: that.addoredit,
                    roleid: that.dataDetail.RoleID,
                    rolename: that.dataDetail.RoleName,
                    groupid: that.dataDetail.GroupName,
                    Lists: that.detailDataTree
                }
                that.$http.urlpost('/Sys/Authority/SaveChildRoleAuthorityTree', parm, function (res) {
                    if (res.Success == 1) {
                        that.isShowDetail = false
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            handleCheck(data,checked){
                let that = this
                let arr = checked.checkedKeys
                let isChecked = false
                for(let i=0;i<arr.length;i++){
                    if(arr[i] == data.PerID){
                        isChecked = true
                        break
                    } else {
                        isChecked = false
                    }
                }
                if(isChecked == true) { // 勾选
                    if(data.Children.length == 0){ // 勾选子节点
                        if(data.PerType == "O"){ // 查询 ，编辑 ， 删除互斥
                            let parentid = data.ParentID
                            let type = 1
                            if(data.PerName == "查询级"){
                                type = 1
                            }  else if (data.PerName == "编辑级"){
                                type = 2
                            } else if(data.PerName == "删除级"){
                                type = 3
                            }
                            that.recursivetrueSon().filter(that.detailDataTree,parentid,type)
                            that.tickMenuIdFilter().filter(that.detailDataTree);
                        } else {
                            if(checked == true){
                                data.IsCheck = true
                            }  else {
                                data.IsCheck = false
                            }
                        }
                    } else { // 勾选父节点
                        that.recursivetrueCancel().filter(data)
                        that.recursivetrue().filter(data)
                    }
                    that.detailDataTree[0].IsCheck = true
                    that.checkParent(data,that.detailDataTree, 'PerID','ParentID', '-')
                    setTimeout(() => {
                        that.tickMenuIdFilter().filter(that.detailDataTree);
                    }, 100);
                } else { // 取消勾选
                    that.recursivetrueCancel().filter(data)
                    that.tickMenuIdFilter().filter(that.detailDataTree);
                }
            },
            // 选中时，勾选其父节点
            checkParent(node, data, PerID, ParentID, rootId){
                let that = this
                if(!node) return;
                if(node[PerID] == rootId) {
                    node.IsCheck = true
                    return;
                }
                let pNode = that.getParentNode(node[ParentID]).filter(data)
                if(!pNode.length) return;
                node.IsCheck = true;
                return that.checkParent(pNode[0], data, PerID, ParentID, rootId);
            },
            recursivetrue: function(){
                let that = this
                let recursiveArray = function(arr){
                    if(arr.Children.length == 0){
                        if(that.maxauthority == false) {
                            if(arr.PerType == "O" && arr.PerName =="查询级"){
                                arr.IsCheck = true
                            }
                        } else {
                            if(arr.PerType == "O" && arr.PerName =="删除级"){
                                arr.IsCheck = true
                            }
                            if(arr.PerType != "O"){
                                arr.IsCheck = true
                            }
                        }
                    } else {
                        arr.IsCheck = true
                        for (let array of arr.Children){
                            recursiveArray(array)
                        }
                    }
                }
                return{
                    filter:function(data){
                        if(data.length == 0){
                            return false
                        }
                        data.IsCheck = true
                        recursiveArray(data)
                        return that.detailDataTree
                    }
                }
            },
            recursivetrueCancel: function(){
                let that = this
                let recursiveArray = function(arr){
                    arr.IsCheck = false
                    if(arr.Children.length != 0){
                        for (let array of arr.Children){
                            recursiveArray(array)
                        }
                    }
                }
                return{
                    filter:function(data){
                        if(data.length == 0){
                            return false
                        }
                        data.IsCheck = false
                        recursiveArray(data)
                        return that.detailDataTree
                    }
                }
            },
            recursivetrueSon:function(){
                let that = this
                let id = ""
                let t = ""
                let recursiveArray = function(arr){
                    if(arr.Children.length != 0 && arr.PerID == id){
                        for(let i = 0;i<arr.Children.length;i++){
                            if(t == 1){
                                if(arr.Children[i].PerName == "查询级"){
                                    arr.Children[i].IsCheck = true
                                }
                                if(arr.Children[i].PerName == "编辑级"){
                                    arr.Children[i].IsCheck = false
                                }
                                if(arr.Children[i].PerName == "删除级"){
                                    arr.Children[i].IsCheck = false
                                }
                            }
                            if(t == 2){
                                if(arr.Children[i].PerName == "查询级"){
                                    arr.Children[i].IsCheck = false
                                }
                                if(arr.Children[i].PerName == "编辑级"){
                                    arr.Children[i].IsCheck = true
                                }
                                if(arr.Children[i].PerName == "删除级"){
                                    arr.Children[i].IsCheck = false
                                }
                            }
                            if(t == 3){
                                if(arr.Children[i].PerName == "查询级"){
                                    arr.Children[i].IsCheck = false
                                }
                                if(arr.Children[i].PerName == "编辑级"){
                                    arr.Children[i].IsCheck = false
                                }
                                if(arr.Children[i].PerName == "删除级"){
                                    arr.Children[i].IsCheck = true
                                }
                            }
                        }
                    }
                    if(arr.Children.length != 0){
                        for (let array of arr.Children){
                            recursiveArray(array)
                        }
                    }
                }
                return{
                    filter:function(data,parentid,type){
                        id = parentid
                        t = type
                        if(data.length == 0){
                            return
                        }
                        for (let rootMenu of data) {
                            recursiveArray(rootMenu)
                        }
                        return that.detailDataTree
                    }
                }
            },
            searchTree(){
                let that = this
                if(that.treeQueryKey == ""){
                    that.$message.warning(that.$t('getapi[8833]'));//'请输入查询关键字！'
                    return
                }
                that.searchIndex = null;
                that.defaultEexpandedkeys = []
                that.searchData = []
                let searchInput = that.treeQueryKey;
                that.getSearchNode().filter(that.detailDataTree)
                if (this.searchData.length) {//存在符合查询条件的节点
                    this.searchIndex = 0;
                    //展开符合条件节点的父节点（使查询节点显示出来）
                    that.defaultEexpandedkeys = that.getParentsId(this.searchData[0], this.detailDataTree, 'PerID','ParentID', '01');
                    console.log(that.defaultEexpandedkeys)
                    this.$nextTick(() => {//显示完成后执行
                        this.$refs.tree.setCurrentKey(this.searchData[0].PerID);//高亮查询到的第一个节点
                    });
                } else {
                    //Message需要引入  import {Message} from 'element-ui'
                    that.$message.warning(that.$t('getapi[8832]'));//'未找到任何匹配数据！'
                }
            },
            next() {
                let that = this
                console.log(that.searchIndex)
                console.log(that.searchData)
                if(that.searchIndex >= that.searchData.length -1){
                    that.$message.warning(that.$t('getapi[8832]'))//'未找到任何匹配数据！'
                    return false
                }
                that.searchIndex += 1;
                that.searchIndex = that.searchIndex < that.searchData.length ? that.searchIndex : 0;
                that.defaultEexpandedkeys = that.getParentsId(that.searchData[that.searchIndex], that.detailDataTree, 'PerID','ParentID', '01');
                this.$nextTick(() => {
                    this.$refs.tree.setCurrentKey(this.searchData[this.searchIndex].PerID);
                    setTimeout(() => {
                        let node = document.querySelector('#searchtree-eletree .is-current');
                        if (node) {
                            setTimeout(() => {
                                // node.scrollIntoView();
                                let top = $(node).position().top;
                                $("#searchtree-eletree").scrollTop(top);
                            }, 500);
                        }
                    }, 0);
                });
            },
            back() {
                let that = this
                if(that.searchIndex == 0){
                    that.$message.warning(that.$t('getapi[8832]'))//'未找到任何匹配数据！'
                    return false
                }
                that.searchIndex -= 1;
                that.defaultEexpandedkeys = that.getParentsId(that.searchData[that.searchIndex], that.detailDataTree, 'PerID','ParentID', '01');
                this.$nextTick(() => {
                    this.$refs.tree.setCurrentKey(this.searchData[this.searchIndex].PerID);
                    setTimeout(() => {
                        let node = document.querySelector('#searchtree-eletree .is-current');
                        if (node) {
                            setTimeout(() => {
                                // node.scrollIntoView();
                                let top = $(node).position().top;
                                $("#searchtree-eletree").scrollTop(top);
                            }, 500);
                        }
                    }, 0);
                });
            },
            getSearchNode:function(){
                let that = this
                let recursiveArray = function(arr){
                    if(arr.PerName.indexOf(that.treeQueryKey) > -1){
                        that.searchData.push(arr)
                    }
                    if(arr.Children.length != 0){
                        for (let array of arr.Children){
                            recursiveArray(array)
                        }
                    }
                }
                return{
                    filter:function(data){
                        if(data.length == 0){
                            return
                        }
                        for (let rootMenu of data) {
                            recursiveArray(rootMenu)
                        }
                        return that.searchData
                    }
                }
            },
            getParentsId(node, data, PerID, ParentID, rootId, parentsId = [] ){
                let that = this
                if(!node) return [rootId, ...parentsId];
                if(node[ParentID] == rootId) return [node[ParentID], ...parentsId];
                let pNode = that.getParentNode(node[ParentID]).filter(data)
                if(!pNode.length) return parentsId;
                parentsId.push(pNode[0][PerID]);
                return that.getParentsId(pNode[0], data, PerID, ParentID, rootId, parentsId);
            },
            position(){
                this.$nextTick(() => {
                    let that = this
                    let top1 = $("#searchtree-eletree").position().top;
                    let top2 = $("#searchtree-eletree .is-current").position().top
                    let value = top2 - top1
                    $("#searchtree-eletree").scrollTop(value)
                })
            },
            getParentNode: function(ParentID){
                let that = this
                let parentID = []
                let recursiveArray = function(arr){
                    if(arr.PerID == ParentID){
                        parentID.push(arr)
                        return
                    } else {
                        for (let array of arr.Children){
                            recursiveArray(array)
                        }
                    }
                }
                return{
                    filter:function(data){
                        if(data.length == 0){
                            return false
                        }
                        for (let rootMenu of data) {
                            recursiveArray(rootMenu);
                        }
                        return parentID
                    }
                }
            },
            del(row){
                let that = this
                let parm = {
                    roleid: row.RoleID,
                    isok: 0
                }
                that.$http.urlpost('/Sys/Authority/DelRoleAuthority', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata()
                    } else if(res.Success == 2){
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                let parm1 = {
                                    roleid: row.RoleID,
                                    isok: 1
                                }
                                that.$http.urlpost('/Sys/Authority/DelRoleAuthority', parm1, function (res1) {
                                    if (res1.Success == 1) {
                                        that.$message.success(that.$processdata.explainCallbackMsg(res1.Msg));
                                        that.intidata()
                                    }
                                })
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .el-form--inline .el-form-item {
        display: flex;
    }

    .tb-edit .el-input {
        display: none
    }

    .tb-edit .current-row .el-input {
        display: block;
    }

    .tb-edit .current-row .el-input + span {
        display: none
    }

    .el-table .hidden-row {
        display: none;
    }
/*    /deep/.el-scrollbar__wrap{
        overflow: scroll;
        overflow-y: scroll;
    }*/
</style>
